var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartCourseDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92319 22.2617L7.01694 21.2422L8.99936 19.373L9.90561 20.3926L13.474 24.1875V11.0469V9.6875H16.1927V11.0469V24.1875L19.7044 20.3926L20.6107 19.373L22.5931 21.2422L21.6869 22.2617L15.7962 28.6055L14.8333 29.625L13.8138 28.6055L7.92319 22.2617ZM14.8333 3.34375C8.31967 3.34375 3.05209 8.61133 3.05209 15.125H0.333344C0.333344 7.13867 6.79037 0.625 14.8333 0.625C22.8197 0.625 29.3333 7.13867 29.3333 15.125V16.4844H26.6146V15.125C26.6146 8.61133 21.2904 3.34375 14.8333 3.34375Z",
    fill: "#DA5252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartCourseDown);
export default __webpack_public_path__ + "static/media/chart-course-down.071fcd6f02171f95b05d504ec7a40001.svg";
export { ForwardRef as ReactComponent };